<template>
  <div class="achievements-volunteers">
    <ag-table :data-source-api="getAllAchievementsVolunteers" :grid-options="gridOptions" :permissions="permissions"
      :is-entities-response="false" @emitExportToExcel="onExportToExcel" @emitImportFromExcel="onImportFromExcel"
      :rtl="false">
    </ag-table>
    <tm-popup :submit="onAchievementPopupSubmit" title="تعديل الإنجاز" ref="achievementVolunteerPopup">
      <div class="vx-row justify-start">
        <div class="vx-col w-full w-full mb-2 mt-2">
          <tm-select class="w-full" :options="getAchievementTypesOptions" label="name" validation-rules="required"
            name="النوع" :reduce="(name) => name.value" v-model="achievement.type" />
        </div>
        <div class="vx-col w-full mb-2 mt-4">
          <p class="mt-2 px-2" style="font-size: smaller">الوصف</p>
          <tm-text-area class="w-full" name="الوصف" validation-rules="required" v-model="achievement.description" />
        </div>
      </div>
    </tm-popup>
  </div>
</template>

<script>
import { RepositoryFactory } from "../volunteer-repositories/volunteerRepositoryFactory";
import AgTable from "../../shared/shared-components/ag-grid/AgTableServerSide.vue";
import AgButton from "@/app/shared/shared-components/ag-grid/AgButton";
import AgTableBtnCell from "../../shared/shared-components/ag-grid/AgTableBtnCell";
import TmPopup from "@/app/shared/shared-components/TmPopup";
import TmTextArea from "@/app/shared/shared-components/TmTextArea";
import TmSelect from "@/app/shared/shared-components/TmSelect";

const tasksRepo = RepositoryFactory.get("tasksRepository");

export default {
  name: "AchievementsVolunteers",
  components: {
    AgTable,
    // eslint-disable-next-line vue/no-unused-components
    AgButton,
    // eslint-disable-next-line vue/no-unused-components
    AgTableBtnCell,
    TmPopup,
    TmTextArea,
    TmSelect
  },
  data() {
    return {
      apiQuery: '',
      gridApi: null,
      gridOptions: null,
      permissions: {
        add: "thank_you_message_management",
        edit: "thank_you_message_management",
        delete: "thank_you_message_management",
        import: "thank_you_message_management",
      },
      achievement: {
        volunteerId: null,
        type: null,
        description: null
      },
      achievementTypes: {
        thanks: 'شكر',
        reward: 'مكافئة',
        contribution: 'مشاركة'
      },
      gender: {
        male: 'ذكر',
        female: 'انثى',
      },
    };
  },
  computed: {
    getAchievementTypesOptions() {
      return Object.keys(this.achievementTypes).map(key => ({
        name: this.achievementTypes[key],
        value: key
      }));
    },
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: "اسم المتطوع",
          field: "volunteer_name",
          filter: "agTextColumnFilter",
          sortable: true,
          width: 200,
        },
        {
          headerName: "رقم البطاقة",
          field: "cardNumber",
          filter: "agTextColumnFilter",
          sortable: true,
          width: 200,
        },
        {
          headerName: "الوصف / الشهر",
          field: "description",
          filter: "agTextColumnFilter",
          sortable: true,
          width: 200,
        },
        {
          headerName: 'الجنس',
          field: 'gender',
          width: 210,
          sortable: false,
          filter: 'agSetColumnFilter',
          filterParams: {
            values: Object.values(self.gender),
          }
        },
        {
          headerName: "النوع",
          field: "type",
          sortable: true,
          width: 200,
          filter: 'agSetColumnFilter',
          filterParams: {
            values: Object.keys(self.achievementTypes),
            valueFormatter: params => {
              return self.achievementTypes[params.value];
            }
          },
          valueGetter:
            function getObject(data) {
              return self.achievementTypes[data.data.type];
            },
        },
        {
          headerName: "الإجراءات",
          cellRendererFramework: AgTableBtnCell,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: {
            editRecord: function (achievement) {
              self.onUpdateAchievement(achievement);
            },
            deleteRecord: function (achievement) {
              self.onRemoveAchievement(achievement);
            },
            actions: ["edit", "delete"],
            permissions: self.permissions,
          },
        },
      ];
    },
    resetAchievementForm() {
      Object.assign(this.achievement, {
        volunteerId: null,
        type: null,
        description: null
      });
    },
    async getAllAchievementsVolunteers(query) {
      this.apiQuery = query;
      return await tasksRepo.fetchAllAchievementsVolunteers(query);
    },
    async onUpdateAchievement(achievement) {
      this.resetAchievementForm();
      Object.assign(this.achievement, achievement);
      this.$refs.achievementVolunteerPopup.open();
    },
    async onRemoveAchievement(achievement) {
      await tasksRepo.removeAchievement(achievement);
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
    async onExportToExcel() {
      await tasksRepo.exportAchievement(this.apiQuery);
    },
    async onImportFromExcel(file) {
      await tasksRepo.importAchievement(file.rawFile);
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
    async onAchievementPopupSubmit() {
      try {
        await tasksRepo.updateAchievement(this.achievement);
        this.$refs.achievementVolunteerPopup.close();
        await this.gridApi.refreshServerSideStore({ purge: true });
      } catch (err) {
        this.$refs.achievementVolunteerPopup.endLoading();
      }
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
};
</script>
